import { loadable } from 'utils';

export const Settings = loadable(() => import('./Settings'), {});
